<!--
 * @Description  : 平台服务 --- 安招采-移动认证服务
 * @Author       : 王帅
 * @Date         : 2026-01-16 09:52:25
 * @LastEditors  : git config user.sname
 * @LastEditTime : 2026-04-28 16:10:19
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\platform-services\mobileCa.vue
-->
<template>
	<div class="h100 audit">
		<!-- 如果选中的是 平台技术服务费 -->
		<auth-skill v-if="activeTab == 'skill'" @tabChange="tabChange"></auth-skill>
		<!-- 列表查询页 -->
		<filter-layout @search="searchName" @reset="reset" hasHeader v-else>
			<template #header>
				<el-tabs v-model="activeTab" @tab-click="tabChange(activeTab)">
					<el-tab-pane name="company" label="平台会员服务"> </el-tab-pane>
					<el-tab-pane name="user" label="移动认证管理"> </el-tab-pane>
					<el-tab-pane name="skill" label="平台技术服务费（包年）"> </el-tab-pane>
				</el-tabs>
			</template>
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="110px">
					<el-form-item label="开通单位" prop="payCompanyName">
						<el-input v-model="searchForm.payCompanyName" placeholder="请输入开通单位" clearable></el-input>
					</el-form-item>
					<el-form-item label="服务类型" prop="goodsCode">
						<el-select v-model="searchForm.goodsCode" placeholder="请选择" clearable>
							<el-option value="0" label="新办"></el-option>
							<el-option value="1" label="续费"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="状态" prop="payStatus">
						<el-select v-model="searchForm.payStatus" placeholder="请选择" clearable>
							<el-option v-for="item in statusArr" :key="item.value" :value="item.value" :label="item.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="税号" prop="payCompanyCreditcode">
						<el-input v-model="searchForm.payCompanyCreditcode" placeholder="请输入税号" clearable></el-input>
					</el-form-item>
					<el-form-item label="权益使用者" prop="userName" v-if="activeTab == 'user'">
						<el-input v-model="searchForm.userName" placeholder="请输入" clearable></el-input>
					</el-form-item>
					<el-form-item label="开通时间" prop="dateArr" class="w50">
						<el-date-picker
							v-model="searchForm.dateArr"
							type="daterange"
							clearable
							ref="datePicker"
							placeholder="请选择"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
					<el-form-item label-width="0">
						<el-button class="btn-blue" type="primary" size="mini" @click="changeDateRange('currentDay')">今日</el-button>
						<el-button class="btn-blue" type="primary" size="mini" @click="changeDateRange('currentMonth')">本月</el-button>
						<el-button class="btn-blue" type="primary" size="mini" @click="changeDateRange('currentYear')">本年</el-button>
					</el-form-item>
				</el-form>
			</template>
			<!-- <template #more>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef2" :model="searchForm" label-width="110px">
					<el-form-item label="权益使用者" prop="userName" v-if="activeTab == 'user'">
						<el-input v-model="searchForm.userName" placeholder="请输入" clearable></el-input>
					</el-form-item>
					<el-form-item label="开通时间" prop="dateArr">
						<el-date-picker
							v-model="searchForm.dateArr"
							type="daterange"
							clearable
							placeholder="请选择"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
				</el-form>
			</template> -->
			<template #content>
				<div class="content-header">
					<div class="mt10 mb10 fr">
						<el-button type="primary" class="btn-blue" size="small" @click="doExport">
							导出
						</el-button>
					</div>
				</div>
				<!-- 非请求参数 正常查看 -->
				<div class="w-table-layout w-table-page">
					<div class="w-table-content bd-table">
						<el-table :data="filiterData" height="100%" highlight-current-row row-key="id" border ref="table" v-if="!loading">
							<el-table-column type="index" label="序号" align="center" width="70"></el-table-column>
							<el-table-column prop="goodsName" label="服务" header-align="center" width="170" show-overflow-tooltip> </el-table-column>
							<el-table-column prop="goodsCode" label="服务类型" align="center" width="120" show-overflow-tooltip>
								<template #default="{ row }">
									<span>{{ statusText('goodsCode', row.goodsCode) }}</span>
								</template>
							</el-table-column>
							<el-table-column label="权益使用者" header-align="center" v-if="activeTab == 'user'">
								<el-table-column
									prop="userName"
									label="姓名"
									header-align="center"
									width="120"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column
									prop="userIdCard"
									label="身份证号"
									header-align="center"
									width="170"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column
									prop="phone"
									label="手机号"
									header-align="center"
									width="150"
									show-overflow-tooltip
								></el-table-column>
							</el-table-column>
							<el-table-column
								prop="payCompanyName"
								label="开通单位"
								header-align="left"
								min-width="200"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column
								prop="payCompanyCreditcode"
								label="税号"
								header-align="left"
								min-width="180"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column prop="payUserName" label="开通人" align="left" width="120" show-overflow-tooltip></el-table-column>
							<el-table-column
								prop="goodsMoney"
								label="支付金额（元）"
								align="right"
								width="120"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column prop="payTime" label="开通时间" align="left" width="150" show-overflow-tooltip></el-table-column>
							<el-table-column
								prop="checkTime"
								label="核销认证时间"
								align="left"
								width="150"
								show-overflow-tooltip
								v-if="activeTab == 'user'"
							></el-table-column>
							<el-table-column
								:prop="activeTab == 'company' ? 'serviceTime' : 'userTime'"
								label="服务有效期"
								align="left"
								width="220"
								show-overflow-tooltip
							>
							</el-table-column>
							<el-table-column prop="payStatus" label="状态" align="left" width="100" show-overflow-tooltip>
								<template #default="{ row }">
									<span>{{ statusText('payStatus', row.payStatus) }}</span>
								</template>
							</el-table-column>
							<el-table-column align="left" width="180" label="操作">
								<template #default="{ row }">
									<el-button type="primary" size="small" round plain class="table-btn" @click="handleBtn('detail', row)">
										查看
									</el-button>
									<!-- row.payStatus == 4 -->
									<el-button
										type="primary"
										size="small"
										v-if="row.closeStatus != 1 && activeTab == 'company'"
										round
										plain
										class="table-btn"
										@click="handleBtn('close', row)"
									>
										关闭服务
									</el-button>
									<el-button
										type="primary"
										size="small"
										v-if="row.payStatus == 4 && activeTab == 'user'"
										round
										plain
										class="table-btn"
										@click="handleBtn('closePay', row)"
									>
										关闭服务
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="w-table-footer">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="currentPage"
							:page-sizes="pageList"
							:page-size="pageSize"
							:total="total"
							layout="total, sizes, prev, pager, next, jumper"
						>
						</el-pagination>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 弹窗 -->
		<detail-dialog :activeTab="activeTab" ref="detailDialog"></detail-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import * as Api from '@/api/modules/platform-service/index'
import { exportPlus } from 'utils/tools'

const detailDialog = () => import('./components/mobileCa-detail.vue')
const authSkill = () => import('./anzhaocai.vue')

export default {
	name: 'audit-affairs-new',
	components: {
		detailDialog,
		authSkill
	},
	data() {
		return {
			activeTab: 'company',
			filiterData: [],
			loading: false,
			tableShow: true,
			//筛选框
			searchForm: {
				payCompanyName: '', //开通公司
				payCompanyCreditcode: '', //税号
				dateArr: [],
				payStartTime: '', //申请开始时间
				payEndTime: '', //申请结束时间
				goodsCode: '', //服务类型
				payStatus: '', //状态
				userName: '' // 权益使用者
			},
			pageList: [10, 20, 30, 50, 100], // 显示条数数组
			currentPage: 1, // 当前页码
			pageSize: 10, // 当前显示条数
			total: 0 // 当前总条数
		}
	},
	created() {
		// 默认当月
		let startDay = this.$utils.getWhatMonth(new Date(), 0, 'first')
		let endDay = this.$utils.getWhatMonth(new Date(), 0, 'last')
		this.searchForm.dateArr = [this.$utils.toDateString(startDay, 'yyyy-MM-dd'), this.$utils.toDateString(endDay, 'yyyy-MM-dd')]
		this.getData()
	},
	methods: {
		// 关闭loading
		realClose() {
			this.realNameLoading = false
		},

		// tab切换
		tabChange(val) {
			this.activeTab = val
			this.$refs.searchRef ? this.$refs.searchRef.resetFields() : ''
			this.$refs.searchRef2 ? this.$refs.searchRef2.resetFields() : ''

			this.currentPage = 1
			this.pageSize = 10
			// 默认当月
			let startDay = this.$utils.getWhatMonth(new Date(), 0, 'first')
			let endDay = this.$utils.getWhatMonth(new Date(), 0, 'last')
			this.searchForm.dateArr = [this.$utils.toDateString(startDay, 'yyyy-MM-dd'), this.$utils.toDateString(endDay, 'yyyy-MM-dd')]
			this.getData()
		},

		// 搜索
		searchName() {
			this.pageSize = 10
			this.currentPage = 1
			this.getData()
		},

		//获得列表数据
		getData(isBack) {
			this.filiterData = []
			if (this.searchForm.dateArr && this.searchForm.dateArr.length > 0) {
				this.searchForm.payStartTime = this.searchForm.dateArr[0] + ' 00:00:00'
				this.searchForm.payEndTime = this.searchForm.dateArr[1] + ' 23:59:59'
			} else {
				this.searchForm.payStartTime = ''
				this.searchForm.payEndTime = ''
			}
			let params = Object.assign({}, this.searchForm)
			delete params.dateArr

			this.loading = true

			// 分页参数
			params.current = this.currentPage
			params.size = this.pageSize
			params.status = this.auditState

			let apiName = this.activeTab == 'company' ? 'selectCompanyFeePage' : 'selectUserFeePage'

			Api[apiName](params)
				.then((res) => {
					this.filiterData = res.data.records
					this.currentPage = parseInt(res.data.current)
					this.total = parseInt(res.data.total)
					this.pageSize = parseInt(res.data.size)
				})
				.catch((err) => {})
				.finally(() => {
					this.loading = false
					setTimeout(() => {
						this.$refs.table ? this.$refs.table.doLayout() : ''
					}, 500)
				})
		},

		//筛选框重置
		reset() {
			this.$refs.searchRef.resetFields()
			this.$refs.searchRef2 ? this.$refs.searchRef2.resetFields() : ''
			this.searchForm.dateArr = []
			this.searchForm.payStartTime = ''
			this.searchForm.payEndTime = ''
			this.pageSize = 10
			this.currentPage = 1
			this.getData()
		},

		//按钮操作
		handleBtn(type, row) {
			row.payStatusText = this.statusText('payStatus', row.payStatus)
			this.$refs.detailDialog.openDialog(type, row)
		},
		//导出
		doExport() {
			if (this.filiterData.length == 0) {
				this.$message.warning('暂无要导出的数据！')
				return
			}
			let params = Object.assign({}, this.searchForm)
			let path = this.activeTab == 'company' ? '/ngsBid/exportCompanyFeePage' : '/ngsBid/exportVerifiedUserFeePage'
			exportPlus(path, params)
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getData()
		},

		// 快捷按钮选项 改变日期
		changeDateRange(type) {
			// 本日
			let dayStart = this.$utils.getWhatDay(new Date(), 0, 'first')
			let dayEnd = this.$utils.getWhatDay(new Date(), 0, 'last')
			// 本月
			let monthStart = this.$utils.getWhatMonth(new Date(), 0, 'first')
			let monthEnd = this.$utils.getWhatMonth(new Date(), 0, 'last')
			// 本年
			let yearStart = this.$utils.getWhatYear(new Date(), 0, 'first')
			let yearEnd = this.$utils.getWhatYear(new Date(), 0, 'last')
			switch (type) {
				case 'currentDay':
					this.searchForm.dateArr = [this.$utils.toDateString(dayStart, 'yyyy-MM-dd'), this.$utils.toDateString(dayEnd, 'yyyy-MM-dd')]
					break
				case 'currentMonth':
					this.searchForm.dateArr = [this.$utils.toDateString(monthStart, 'yyyy-MM-dd'), this.$utils.toDateString(monthEnd, 'yyyy-MM-dd')]
					break
				case 'currentYear':
					this.searchForm.dateArr = [this.$utils.toDateString(yearStart, 'yyyy-MM-dd'), this.$utils.toDateString(yearEnd, 'yyyy-MM-dd')]
					break
			}
			this.getData()
		}
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),

		...mapState('user', { userInfo: (state) => state.userInfo }),

		// 支付状态码表
		statusArr() {
			let arr = [
				{ value: '0', label: '生效中' },
				{ value: '1', label: '已失效' },
				{ value: '2', label: '已关闭' },
				{ value: '3', label: '待生效' }
			]

			if (this.activeTab == 'user') {
				arr.push({ value: '4', label: '待核销' })
			}
			return arr
		},

		// 不同码表展示的文字
		statusText() {
			let text = ''
			let that = this
			return function(type, value) {
				switch (type) {
					// 服务类型
					case 'goodsCode':
						text = value !== '' ? ['新办', '续费'][parseFloat(value)] : ''
						break
					// 状态
					case 'payStatus':
						let item = that.statusArr.find((x) => parseFloat(x.value) === parseFloat(value))
						text = item && item.label ? item.label : ''
						break
				}
				return text
			}
		},

		// 日期选择快捷选项
		pickerOptions() {
			let that = this
			// 本日
			let dayStart = this.$utils.getWhatDay(new Date(), 0, 'first')
			let dayEnd = this.$utils.getWhatDay(new Date(), 0, 'last')
			// 本月
			let monthStart = this.$utils.getWhatMonth(new Date(), 0, 'first')
			let monthEnd = this.$utils.getWhatMonth(new Date(), 0, 'last')
			// 本年
			let yearStart = this.$utils.getWhatYear(new Date(), 0, 'first')
			let yearEnd = this.$utils.getWhatYear(new Date(), 0, 'last')
			return {
				shortcuts: [
					{
						text: '今日',
						onClick(picker) {
							console.log('😍 ~ picker:', picker)
							picker.$emit('pick', [dayStart, dayEnd])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					},
					{
						text: '本月',
						onClick(picker) {
							picker.$emit('pick', [monthStart, monthEnd])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					},
					{
						text: '本年',
						onClick(picker) {
							picker.$emit('pick', [yearStart, yearEnd])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					},
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
							picker.$emit('pick', [start, end])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					},
					{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
							picker.$emit('pick', [start, end])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					}
				]
			}
		}
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		}

		// // 监听路由参数 --- 回到主界面时刷新查询
		// $route(params) {
		// 	let arr = Object.keys(params.query)
		// 	if (arr.length === 0) {
		// 		this.getData()
		// 	}
		// }
	}
}
</script>

<style scoped lang="less">
.audit {
	.searchBox {
		padding-top: 8px;
	}

	/deep/ .more-layout {
		top: 55px;
		right: 370px;
	}

	/deep/ .el-tabs__item {
		// width: 100px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		background: #f0f0f0;
		border-radius: 3px 3px 0px 0px;
		color: #666;
		margin-right: 20px;
		padding: 0 15px !important;

		.el-tabs__header {
			border-bottom: 1px solid #2671cc;
		}
	}

	/deep/ .el-tabs__item.is-active {
		color: #fff;
		background-color: #2671cc !important;
	}

	/deep/ .el-tabs__nav-wrap::after {
		background-color: #2671cc;
		height: 1px;
		z-index: 999;
	}

	/deep/ .el-tabs__active-bar {
		background-color: transparent;
	}

	.auditMsg {
		color: #2671cc;
		cursor: pointer;
	}

	.green,
	.red,
	.orange {
		display: inline-block;
		height: 28px;
		line-height: 28px;
		padding: 0 10px;
		font-size: 12px;
		border-radius: 5px;
	}

	.green {
		background: #e9f6f2;
		border: 1px solid #bff5e5;
		color: #39c098;
	}

	.red {
		background: #feeff0;
		border: 1px solid #fde2e2;
		color: #f56c6c;
	}

	.orange {
		background: #fdf6ec;
		border: 1px solid #faecd8;
		color: #e7a23c;
	}

	.toolbar {
		position: relative;

		.toolbar-right {
			position: absolute;
			right: 0;
			top: 0;
		}
	}

	/deep/ .el-table__header-wrapper {
		tr > th {
			padding: 6px 0 !important;
			height: 50px !important;
		}
	}

	.item {
		position: absolute !important;
		right: -15px;
	}
}

.sHeight {
	padding: 0;
}

.view-ca-dia {
	/deep/ .el-dialog__header {
		background-color: #2671cc;

		span,
		.el-dialog__close {
			color: #fff;
			font-weight: normal;
		}
	}

	.fontWeightBold {
		color: #202020;
		font-size: 16px;
	}

	.left {
		color: #202020;
		font-weight: 600;
	}

	.right {
		color: #666666;
		text-align: right;
	}
}

.audit-company-dialog {
	/deep/ .el-dialog__body {
		max-height: 700px !important;
	}
}

@media screen and (max-height: 900px) {
	/deep/ .el-dialog__body {
		max-height: 560px !important;
	}

	.audit-company-dialog {
		/deep/ .el-dialog__body {
			max-height: 560px !important;
		}
	}
}

@media screen and (max-height: 660px) {
	/deep/ .el-dialog__body {
		max-height: 440px !important;
	}

	.audit-company-dialog {
		/deep/ .el-dialog__body {
			max-height: 440px !important;
		}
	}
}
</style>
